import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader } from "../../Generic/AppCard";
import NotesText from "./NotesText";

interface Props {
  title: string;
  notes: string | null;
}

const NotesCard = (props: Props) => {
  const notes = React.useMemo(() => {
    if (props.notes !== null && props.notes !== "") {
      return props.notes;
    }

    return (
      <span style={{ opacity: 0.75 }}>{translate(STRINGS.THERE_SEEMS_TO_BE_NOTHING_HERE)}</span>
    );
  }, [props.notes]);

  return (
    <AppCard className="NotesCard">
      <AppCardHeader>{props.title}</AppCardHeader>
      <AppCardContent>
        <NotesText>{notes}</NotesText>
      </AppCardContent>
    </AppCard>
  );
};

export default NotesCard;
